<!-- =========================================================================================
    File Name: ForgotPassword.vue
    Description: Forgot Password Page
========================================================================================== -->


<template>
  <div class="md:h-screen flex w-full">
    <div class="background-illus">
      <img class="top-illus" src="@/assets/images/forget-password/Ellipse1.svg" alt="">
      <img class="bottom-illus" src="@/assets/images/forget-password/Ellipse2.svg" alt="">
    </div>
    <div class="vx-col w-4/5 sm:w-4/5 md:w-3/5 lg:w-3/4 xl:w-3/5 mx-auto self-center">
      <vx-card>
        <div slot="no-body">
          <div class="vx-row box main-section">
            <!-- Start Left Side -->
            <div class="vx-col lg:block lg:w-1/2 mx-auto self-center">
              <a target="_blank" @click="$gtag.event('signup-logo-image')" href="https://speakol.com/?ref=advertisers-signin">
                <img src="@/assets/images/speakol.svg" alt="login" class="forget-password-logo logo-img">
              </a>
              <div class="w-full text-center">
                <img src="@/assets/images/sign-up.svg" class="forget-password-pig-picture sm:w-full pt-2 pt-10" alt="forget password">
              </div>
            </div>
            <!-- End Left Side -->

            <!-- Start Right Side -->
            <div class="vx-col sm:w-full md:w-full lg:w-1/2 mx-auto self-center">
              <div class="section-parent">
                <div class="vx-card__title">
                  <h4 class="mb-4">Forgot password</h4>
                  <p class="forget-password-desc">Please enter your email address and we'll send you instructions on how to reset your password..</p>
                </div>

                <div class="">
                  <div class="">
                    <vs-input
                      id="forget-password-email-input"
                      v-validate="'required|email|max:230'"
                      name="email"
                      icon-no-border
                      icon="speakol-email"
                      icon-pack="speakol"
                      placeholder="Email"
                      v-model="email"
                      class="w-full forget-password-input"/>

                    <span class="text-danger text-sm" v-show="errors.has('email')">{{ errors.first('email') }}</span>
                  </div>

                  <div class="button-parent">
                    <vs-button id="forget-password-send-button" class="forget-password-buttons float-right px-4 w-full speakol-background" @click="sendEmail">Send</vs-button>

                    <vs-button id="forget-password-back-to-sign-in-button" type="border" to="/login" class="back-to-button forget-password-buttons px-4 w-full">Back To Sign In</vs-button>
                  </div>

                  <p class="vx-col self-center text-xs mt-3">
                    This site is protected by reCAPTCHA and the Google
                    <a id="forget-password-privacy-policy-button" target="_black" href="https://policies.google.com/privacy">Privacy Policy</a> and
                    <a id="forget-password-terms-of-service-button" target="_black" href="https://policies.google.com/terms">Terms of Service</a> apply.
                  </p>
                </div>
              </div>
            </div>
            <!-- End Right Side -->
          </div>
        </div>
      </vx-card>

      <!-- Start Success Popop -->
      <div class="demo-alignment">
        <vs-popup class="holamundo px-5 py-10" :active.sync="popupActive">
          <div class="text-center md:mt-4">
            <img src="@/assets/images/pages/user-password/success.png">
          </div>
          <p class="text-center md:py-3"> An email has been sent to your account, please check your email.</p>

          <div class="space-y-3 m-3">
            <div class="text-center">
              <vs-button class="md:w-2/5 w-full speakol-background rounded shadow-none" @click="gotIt">Got It</vs-button>
            </div>
            <div class="text-center">
              <vs-button type="border" class="md:w-2/5 w-full rounded shadow-none" @click="sendEmail(false)">Resend</vs-button>
            </div>
          </div>
        </vs-popup>
      </div>
      <!-- End Success Popop -->

    </div>
  </div>
</template>

<style lang="scss" src="./style.scss"></style>

<script>

import get from 'lodash/get'
import first from 'lodash/first'
import isObject from 'lodash/isObject'
import isString from 'lodash/isString'

export default {
  data () {
    return {
      email: undefined,
      token: null,
      popupActive: false
    }
  },
  methods: {
    async gotIt () {
      this.popupActive = false

      setTimeout(() => {
        this.$router.push({ name: 'login' })
      }, 500)
    },

    async sendEmail (showPopup = true) {

      const submitBtn = event.target

      await this.$validator.validateAll()

      if (this.errors.any()) return

      submitBtn.disabled = true

      this.$store.dispatch('authentication/sendForgetPasswordEmail', {
        'email': this.email
      }).then(() => {
        submitBtn.disabled = false

        if (showPopup) {
          this.popupActive = true
        }
      }).catch((error) => {
        submitBtn.disabled = false
        if (this.is4xxError(error) && this.isEmailFieldError(error) && this.hasErrorCode(error)) {
          this.renderEmailFieldError(error)
        } else {
          this.$setLaravelValidationErrorsFromResponse(error.response.data)
        }
      })
    },

    is4xxError (error) {
      const statusCode = parseInt(get(error, 'response.status'))
      return statusCode && statusCode  < 500 && statusCode >= 400
    },

    isEmailFieldError (error) {
      const emailError = get(error, 'response.data.errors.email')
      return isObject(emailError) || Array.isArray(emailError)
    },

    hasErrorCode (error) {
      return isString(get(error, 'response.data.errors.email.[0].code'))
    },

    renderEmailFieldError (error) {
      const backendErrors = first(get(error, 'response.data.errors.email'))
      const { message } = backendErrors
      this.errors.add({
        field: 'email',
        msg: message
      })
    }

  }
}
</script>

<style lang="scss">
  .forget-password-logo {
    width: 110px;
    height: auto;
  }

  .forget-password-buttons {
    border-radius: 3px;
  }

  .forget-password-input {
    i {
      color: #dadada;
      top: 6px !important;
    }
  }

  .top-illus,
  .bottom-illus {
    position: absolute;
  }

  .bottom-illus {
    bottom: 0;
    right: 0;
  }

  .forget-password-pig-picture {
    width: 310px !important;
    margin-top: 30px;
  }

  .section-parent {
    padding-top: 52px;
    padding-bottom: 52px;
    padding-left: 38px;
    padding-right: 38px;
  }

  .back-to-button {
    margin-top: 16px;
    border: 1px solid #0092d7 !important;
    color: #0092d7 !important;
  }

  .button-parent {
    margin-top: 30px !important;
  }

  .forget-password-desc {
    margin-bottom: 30px;
  }

  .logo-img {
    top: 13% !important;
  }

  @media (max-width: 576px) {
    .forget-password-pig-picture {
      padding: 20px;
      padding-bottom: 0;
      margin-top: 40px !important;
    }

    .section-parent {
      padding: 20px !important;
    }

    .logo-img {
      top: 4% !important;
    }
  }
</style>
